import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';

import { postEmail } from 'Redux/ducks/email-subscribe';
import { toggleEmailSubscribeModal as toggleEmailSubscribeModalAction } from 'Redux/ducks/modal';
import getSubscribeContext from 'Helpers/CRM/subscribe-context';
import useEmailSubscribeFeedback from 'Hooks/Acquisition/useEmailSubscribeFeedback';
import store from 'Redux/store';

import 'Components/Input/EmailSubscribeInput.scss';

const EmailSubscribeInput = ({
  auth,
  mobileEnabled,
  toggleEmailSubscribeModal,
  appearsOn,
}) => {
  const [email, setEmail] = useState('');

  const intl = useIntl();

  const context = getSubscribeContext(appearsOn);
  const handleChange = (event) => {
    event.preventDefault();
    setEmail(event.target.value, false);
  };

  const optinEmail = (event, emailPassed, optin) => {
    event.preventDefault();
    store.dispatch(postEmail(emailPassed, context, optin, true));
  };

  const handleSubmit = (event) => {
    optinEmail(event, email, true);
  };

  useEmailSubscribeFeedback(context);

  if (mobileEnabled) {
    return (
      <div id={`emailsignup-${context}`} className="email-subscribe-input">
        <button
          className="btn-block email-single-btn pb-0 pt-0 pl-3 pr-3"
          onClick={() => toggleEmailSubscribeModal()}
        >
          <FormattedMessage id="subscribe.input.mobile-subscribe" defaultMessage="Subscribe" />
        </button>
      </div>
    );
  }

  return (
    <div id={`emailsignup-${context}`} className="email-subscribe-input">
      {auth.authenticated &&
        <button
          className="btn-block email-single-btn pb-0 pt-0 pl-3 pr-3"
          onClick={event => optinEmail(event, auth.email, true)}
        >
          <FormattedMessage id="subscribe.input.button-subscribe" defaultMessage="Subscribe" />
        </button>
      }
      {!auth.authenticated &&
        <React.Fragment>
          <form onSubmit={handleSubmit}>
            <div className="input-group" style={{ width: '280px' }}>
              <input
                required
                placeholder={intl.formatMessage({ id: 'email-subscribe-nav.placeholder', defaultMessage: 'Enter your email' })}
                className="form-control"
                type="email"
                name="email"
                title="Enter your email address"
                enterKeyHint="send"
                aria-label="email"
                value={auth.email}
                onChange={handleChange}
              />
              <span className="input-group-append">
                <button className="btn btn-primary pb-0 pt-0 pl-3 pr-3" type="submit">
                  <FormattedMessage id="subscribe.input.input-subscribe" defaultMessage="Subscribe" />
                </button>
              </span>
            </div>
          </form>
        </React.Fragment>
      }
    </div>
  );
};

EmailSubscribeInput.propTypes = {
  auth: PropTypes.shape({}),
  mobileEnabled: PropTypes.bool,
};

EmailSubscribeInput.defaultProps = {
  auth: {},
  mobileEnabled: false,
};

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = {
  toggleEmailSubscribeModal: toggleEmailSubscribeModalAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailSubscribeInput);
